

export function patchRequest(payload) {
    const csrf = getCsrfToken();
    
    return {
        method: "PATCH",
        body: JSON.stringify(payload),
        headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": csrf
        },
        credentials: "include",
    }
}


export function getRequest() {
    return {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include"
    };
}

export function getCsrfToken() {
    const name = "csrftoken";

    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            if (cookie.startsWith(name + '=')) {
                return decodeURIComponent(
                    cookie.substring(name.length + 1)
                );
            }
        }
    }

    return "error";
}

export function postRequest(payload) {
    const csrf = getCsrfToken();
    
    return {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": csrf
        },
        credentials: "include"
    };
}
export function postFormRequest(form_data) {
    const csrf = getCsrfToken();
    
    return {
        method: "POST",
        body: form_data,
        headers: {
            "X-CSRFToken": csrf
        },
        credentials: "include"
    };
}

export function deleteRequest() {
    const csrf = getCsrfToken();
    
    return {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": csrf
        },
        credentials: "include"
    };
}